/* eslint-disable react/no-danger */
import React from 'react'

import {
  arrayOf, object, objectOf, shape, string,
} from 'prop-types'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import LinkRow from './Components/LinkRow/LinkRow'

const GROUPS = [
  { group: 'relevance', labelKey: 'search_page.seo_area.by_relevance' },
  { group: 'extensions', labelKey: 'search_page.seo_area.by_extension' },
  { group: 'style', labelKey: 'search_page.seo_area.by_style' },
]

function SeoArea({
  title,
  description = '',
  linkGroups = EMPTY_OBJECT,
  typeLinks = EMPTY_ARRAY,
  rootPath = '',
}) {
  const translate = useTranslate()

  // seo_link_groups returns nil once every group is blank, and a default parameter only covers
  // undefined - null would throw on the lookup below and 500 the prerender.
  const groups = linkGroups || EMPTY_OBJECT

  // ValidBrowseByTypeUrls builds a variant per filter regardless of which page it runs on, so the
  // current page can appear among them - never link a page to itself.
  const typeLinksWithoutSelf = typeLinks.filter(link => link.categoryUrl !== rootPath)

  return (
    <div className="seo-area">
      <div className="seo-area__intro">
        <h1 className="seo-area__title cgt-heading-100">{title}</h1>
        {/* Server-rendered copy from BrowserDecorator#subtitle; the URL tag it interpolates is escaped there. */}
        {description && (
          <div
            className="seo-area__description cgt-body-base"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
      <div className="seo-area__rows">
        {GROUPS.map(({ group, labelKey }) => (
          <LinkRow
            key={group}
            label={translate(labelKey)}
            links={groups[group] || EMPTY_ARRAY}
          />
        ))}
        <LinkRow
          label={translate('search_page.seo_area.by_type')}
          links={typeLinksWithoutSelf}
        />
      </div>
    </div>
  )
}

SeoArea.propTypes = {
  title: string.isRequired,
  description: string,
  linkGroups: objectOf(arrayOf(object)),
  typeLinks: arrayOf(shape({
    tag: string,
    categoryUrl: string,
  })),
  rootPath: string,
}

export default SeoArea
